import React, { useState } from "react";
import { writeDataInDB } from "../../firebase/database";
import styles from "./index.module.scss";

const initialFormState = {
  name: "",
  email: "",
  organization: "",
  phone: "",
};

const FeedbackForm = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    // if (!formData.organization)
    //   newErrors.organization = "Organization is required";
    // if (!formData.phone) newErrors.phone = "Phone number is required";
    // Add more validations as needed

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        await writeDataInDB("/formData", formData);
        setFormData(initialFormState);
        setErrors({});
        // Handle success
        alert("Form submitted successfully!");
      } catch (error) {
        // Handle error
        alert("There was an error submitting the form.");
        console.error(error);
      }
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.formContainer} onSubmit={handleSubmit}>
        <img
          className={styles.logo}
          src={require("../../assets/images/logo.png")}
          alt="VENTI"
        />
        <h1 className={styles.heading}>Want a Faster, Smarter</h1>
        <h1 className={styles.subHeading}>Event Registration?</h1>
        <p className={styles.para}>
          Enter your details, and we’ll get back to you with a customized demo
        </p>
        <div className={styles.inputGroup}>
          <label>Name*</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="error">{errors.name}</p>}
        </div>
        <div className={styles.inputGroup}>
          <label>Email*</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>
        <div className={styles.inputGroup}>
          <label>Organization</label>
          <input
            type="text"
            name="organization"
            value={formData.organization}
            onChange={handleChange}
          />
          {errors.organization && (
            <p className="error">{errors.organization}</p>
          )}
        </div>
        <div className={styles.inputGroup}>
          <label>Phone Number</label>
          <div className={styles.inputWithCountry}>
            <div className={styles.code}>+91</div>
            <input
              type="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              style={{
                border: 0,
                borderRadius: 0,
                borderLeft: "2px solid #3879db"
              }}
            />
          </div>
          {errors.phone && <p className="error">{errors.phone}</p>}
        </div>
        <button className={`btn`} type="submit">
          Book a Demo
        </button>
      </form>
    </div>
  );
};

export default FeedbackForm;
